import type * as React from 'react';
import { type FC, useEffect, useRef } from 'react';

import { useAmplitude } from '@crehana/analytics';
import { useIntersectionObserver } from '@crehana/react-hooks';

export interface TrackUserScrollProps {
  amplitudePageName: string;
  sectionName: string;
}

const TrackUserScroll: FC<React.PropsWithChildren<TrackUserScrollProps>> = ({
  amplitudePageName,
  sectionName,
}) => {
  const ref = useRef(null);
  const observer = useIntersectionObserver(ref, { freezeOnceVisible: true });
  const { logEvent } = useAmplitude();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  useEffect(() => {
    if (observer?.isIntersecting) {
      logEvent({
        event: 'User Scrolled',
        data: {
          'Source Detail': amplitudePageName,
          Section: sectionName,
        },
      });
    }
  }, [observer?.isIntersecting]);

  return <div ref={ref} />;
};

export default TrackUserScroll;
